<template>
  <section
    class="document-mobile-banner d-flex align-end pa-4 mb-6 overflow-hidden position-relative"
    data-qa="document_mobile_banner"
    :style="bannerStyle"
  >
    <div class="info-banner__overlay_darken position-absolute" />
    <div class="text-subtitle-1 bg-gray-0--text pa-4 rounded w-100 position-relative">
      <ul class="document-mobile-banner__list ma-0 pa-0">
        <li class="mb-3">
          {{ t('ООО «МЕДРОКЕТ»', options) }}
        </li>
        <li
          v-if="isRussia"
          class="mb-3"
        >
          {{ t('ОГРН 1122311003760', options) }}
        </li>
        <li v-if="isRussia">
          {{ t('ЭЛ № ФС 77 - 89293 от 01.04.2025 г', options) }}
        </li>
      </ul>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import I18NextVue from 'i18next'

const { t, language } = I18NextVue
const options = { ns: language }

const props = defineProps<{
  staticPath: string
  isRussia: boolean
}>()

const bannerStyle = computed(() => ({
  backgroundImage: `url('${props.staticPath}_v1/pd/banners/document-banner.jpeg')`,
}))
</script>

<style scoped lang="scss">
.document-mobile-banner {
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;

  &__list {
    list-style: none;
  }
}

.info-banner__overlay_darken {
  background: rgba(54, 54, 54, .6);
  inset: 0;
}
</style>
